import { StudyScoreClient } from 'jf/api';
import { useClientQuery } from 'jf/utils/useClientQuery';

export const useStudyDevExIndex = (props: { studyRef: string | undefined; teamRef?: string }) => {
  const { data: devexIndex } = useClientQuery(StudyScoreClient.getStudyDevexIndex, {
    studyRef: props.studyRef,
    ...(props.teamRef ? { teamRef: props.teamRef } : {}),
  });

  return { devexIndex: devexIndex?.index };
};
